import { styled } from '@mui/styles';

export const ViewContainer = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
    '& > h3': {
        marginBottom: 40,
    },
    '& > .card': {
        width: 451,
        boxSizing: 'border-box',
        padding: 18,
        background: '#FFFFFF',
        border: '1px solid #E4E6EB',
        boxShadow: '0px 2px 6px rgba(112, 144, 176, 0.07)',
        borderRadius: 8,
        '& > .header': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& > p': {
                fontWeight: 500,
                fontSize: 15,
                color: theme.palette.subline,
            },
        },
        '& > .section-title': {
            marginTop: 8,
            color: theme.palette.lightGrey,
        },
    },
}));
